<vp-image
	[image]="slideImage()"
	[maxWidth]="maxWidth()"
	[sizes]="sizes()"
	class="block h-full"
	className="size-full"
/>
